module.exports = __webpack_public_path__ + "img/high-five-active.fc048dbb.svg";